import { LOCAL_STORAGE_LOGIN_TOKEN_KEY } from "src/config/axios";
import { getAppEnvironment } from "./dataParsing";
import { isNativeApp } from "./nativeUtils";

// ---------------- TOKEN ----------------------

const getTokenKey = () => {
  const environment = getAppEnvironment();
  const hasEnvironmnt = environment && environment.length;

  if (isNativeApp() || !hasEnvironmnt) return LOCAL_STORAGE_LOGIN_TOKEN_KEY;

  return `${LOCAL_STORAGE_LOGIN_TOKEN_KEY}-${environment}`;
};

export const getLocalStorageLoginToken = () =>
  localStorage.getItem(getTokenKey());

export const setLocalStorageLoginToken = (token: string) =>
  localStorage.setItem(getTokenKey(), token);

export const removeLocalStorageLoginToken = () =>
  localStorage.removeItem(getTokenKey());
